import { render, staticRenderFns } from "./newsTypeEdit.vue?vue&type=template&id=88bd9620"
import script from "./newsTypeEdit.vue?vue&type=script&lang=js"
export * from "./newsTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88bd9620')) {
      api.createRecord('88bd9620', component.options)
    } else {
      api.reload('88bd9620', component.options)
    }
    module.hot.accept("./newsTypeEdit.vue?vue&type=template&id=88bd9620", function () {
      api.rerender('88bd9620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/newsTypeSet/newsTypeEdit.vue"
export default component.exports